import React from 'react';
import { RiArrowRightSLine } from 'react-icons/ri';
import Link from 'next/link';
import { Box, Button, Flex } from '@itandi/itandi-bb-ui';
import Styles from './ChatMessagePaneHeader.module.scss';
import { useMessageSelectedContext } from '~/components/common/chat/ChatPagesContainer';
import { PATH as CLIENT_PATH } from '~/pages/deals/[id]';
import { PATH as VENDOR_PATH } from '~/pages/vendors/deals/[id]';

type Props = DeepReadonly<{
  isVendor?: boolean;
  isAdmin?: boolean;
  handleTemporaryUnread: (dealId: number) => Promise<void>;
  isDisabledUnreadButton: boolean;
}>;

export const ChatMessagePaneHeader: React.FC<Props> = ({
  isVendor = false,
  isAdmin = false,
  isDisabledUnreadButton,
  handleTemporaryUnread
}: Props) => {
  const { selectedSummary, setSelectedSummary } = useMessageSelectedContext();
  const onClickClose = React.useCallback(
    (e: React.MouseEvent): void => {
      e.preventDefault();
      setSelectedSummary && setSelectedSummary(null);
    },
    [setSelectedSummary]
  );
  if (selectedSummary === null) {
    return <></>;
  }
  const onClickTemporaryUnread = React.useCallback((): void => {
    handleTemporaryUnread && handleTemporaryUnread(selectedSummary.deal.id);
    setSelectedSummary && setSelectedSummary(null);
  }, [handleTemporaryUnread, selectedSummary.deal.id, setSelectedSummary]);
  return (
    <div className={Styles.HeaderContainer}>
      <h3 className={Styles.TimelineHeader}>
        <Flex>
          <Box marginTop="0.25rem">
            <Flex>
              <Box>
                <a className={Styles.CloseLink} href="#" onClick={onClickClose}>
                  <RiArrowRightSLine className={Styles.CloseIcon} />
                </a>
              </Box>
              <Box w="15rem">
                <div
                  className={Styles.RoomName}
                >{`${selectedSummary.deal.name} ${selectedSummary.deal.roomNumber}`}</div>
                <div className={Styles.PartnerName}>
                  {isVendor
                    ? selectedSummary.deal.companySetting.name
                    : selectedSummary.deal.originVendorCompany?.name}
                </div>
              </Box>
              {selectedSummary.lastSendAt !== null && (
                <Flex alignSelf="center" marginLeft="1rem">
                  <Button
                    disabled={isAdmin || isDisabledUnreadButton}
                    height="small"
                    onClick={onClickTemporaryUnread}
                    variant="secondary"
                  >
                    未読ラベルをつける
                  </Button>
                </Flex>
              )}
            </Flex>
          </Box>
        </Flex>
      </h3>
      <div className={Styles.LinkWrapper}>
        <Link
          className={Styles.DealLink}
          href={
            isVendor
              ? VENDOR_PATH(selectedSummary.deal.id)
              : CLIENT_PATH(selectedSummary.deal.id)
          }
          target="_blank"
        >
          案件詳細
        </Link>
      </div>
    </div>
  );
};
